import React, { useState } from "react";
import GcStudentMasterLayout from "../../../layouts/gcstudent/GcStudentMasterLayout";

import HeroSection from "../../../components/gcstudent/aboutsection/HeroSection";
import DigitalLibraryBooks from "../../../subsreens/gcstudent/digitallibrarybooks/DigitalLibraryBooks";


const GcDigitalLibrary = () => {
     const DigitalData = { title: 'Digital', highLight: 'Library', subTitle: 'Access and download PDF books. Read online or save for offline reading.' };

    const [selectedBook, setSelectedBook] = useState(null);

    return <>
        <GcStudentMasterLayout>
            {!selectedBook && <HeroSection heroData={DigitalData} />}

            <DigitalLibraryBooks selectedBook={selectedBook} setSelectedBook={setSelectedBook} />

        </GcStudentMasterLayout>

    </>
}

export default GcDigitalLibrary;